import React from 'react'
import { connect } from 'react-redux'
import { claimActions } from '../../../redux/actions'
import FormattedMessage from '../../../components/FormattedMessage/FormattedMessage'
import NoMoreCreditsModal from '../../../components/Modal/NoMoreCreditsModal/NoMoreCreditsModal'
import Loader from '../../../components/Loader/Loader'
import ClaimNavigation from '../../../components/ClaimNavigation/ClaimNavigation'
import Error from '../../../components/Error/Error'
import SelectContent from './SelectContent'

import './Select.scss'

class Select extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeContentId: null,
      modalOpen: false,
    }
  }

  componentDidMount() {
    const { couponCode, currentPromotion, getPromotionByCouponCode } = this.props

    if (!currentPromotion) {
      getPromotionByCouponCode(couponCode)
      return
    }

    this.setFirstAvailableContent()
  }

  componentDidUpdate(prevProps) {
    const { activePromotionStepId, currentPromotion } = this.props
    const { activeContentId } = this.state

    // See if activePromotionStepId changed
    const onLoad = currentPromotion && !prevProps.currentPromotion
    const activeChange = prevProps.activePromotionStepId !== activePromotionStepId
    const noActiveContent = currentPromotion && !activeContentId

    // Fetch promotionStepContent if activePromotionId has been updated
    if (onLoad || activeChange || noActiveContent) {
      this.setFirstAvailableContent()
    }
  }

  setFirstAvailableContent = () => {
    const { activePromotionStepId, currentPromotion, setActivePromotionStep } = this.props
    if (!currentPromotion) return

    let nextStep
    if (!activePromotionStepId) {
      // Set the activePromotionId to top of the sorted promotion steps
      ;[nextStep] = currentPromotion.promotionSteps
      setActivePromotionStep(nextStep && nextStep.id)
    } else {
      nextStep = currentPromotion.promotionSteps.find(temp => temp.id === activePromotionStepId)
    }

    if (!nextStep) return

    const redeemedContent = nextStep.redeemedContent || []
    const promotionStepContent = nextStep.promotionStepContent || []
    const availableContent = promotionStepContent.filter(
      content =>
        redeemedContent.map(redeemed => redeemed.contentId).indexOf(content.contentId) === -1
    )

    if (availableContent.length) {
      this.setState({ activeContentId: availableContent[0].contentId })
    }
  }

  _toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen })
  }

  _setActiveContent = (e, content) => {
    e.preventDefault()
    this.setState({ activeContentId: content.contentId })
  }

  _deselectContent = content => {
    this.props.deselectContent(this.props.activePromotionStepId, content)
  }

  _activePromotionStep = () =>
    this.props.currentPromotion &&
    this.props.currentPromotion.promotionSteps &&
    this.props.currentPromotion.promotionSteps.find(
      promotionStep => promotionStep.id === this.props.activePromotionStepId
    )

  _getPromotionStepContentList = () => {
    const activePromotionStep = this._activePromotionStep()
    return activePromotionStep && activePromotionStep.promotionStepContent
  }

  _hasActivePromotionStep = () => this.props.currentPromotion && this.props.activePromotionStepId

  _getCurrentContentList = () => {
    const contentList =
      this.props.selectedContentList.find(
        promotionStep => promotionStep.promotionStepId === this.props.activePromotionStepId
      ) || []
    return contentList
  }

  _getCurrentCredits = () =>
    this._hasActivePromotionStep() ? this._activePromotionStep().currentCreditsUsed : 0

  _getMaximumSelections = () => {
    if (!this._hasActivePromotionStep()) {
      return 0
    }
    const activePromotionStep = this._activePromotionStep()
    return activePromotionStep.maximumSelections - activePromotionStep.creditsUsed
  }

  _getRedeemedContent = () =>
    this._hasActivePromotionStep() ? this._activePromotionStep().redeemedContent : []

  _getActiveContent = () => {
    const { activeContentId } = this.state
    const promotionStepContentList = this._getPromotionStepContentList()
    return (
      promotionStepContentList &&
      promotionStepContentList.find(content => content.contentId === activeContentId)
    )
  }

  _renderGameAndSoftwareCount = () => {
    const activePromotionStep = this._activePromotionStep()
    return (
      <div>
        <p>
          {activePromotionStep && (
            <FormattedMessage
              id="page.redemptionPage.text.rewardOffer"
              values={{ contentType: activePromotionStep.promotionStepType.description }}
            />
          )}
          <br />
          <FormattedMessage id="page.redemptionPage.text.selectAndRedeem" />
        </p>
      </div>
    )
  }

  _renderSelectedCredits = () => {
    const currentCreditsUsed = this._getCurrentCredits()
    const maximumSelections = this._getMaximumSelections()
    const currentContentList = this._getCurrentContentList()
    const promotionStepContentList = this._getPromotionStepContentList()
    return (
      <div className="select-selected-credits card h-100">
        <div className="card-body">
          <h6>
            <FormattedMessage id="global.label.selectedCredits" />
            {` ${currentCreditsUsed}/${maximumSelections}`}
          </h6>
          <div className="hr mb-2" />
          {currentContentList.selectedContent && currentContentList.selectedContent.length > 0 ? (
            currentContentList.selectedContent.map(currentContent => (
              <div className="row m-0 mb-2" key={`selected-content-${currentContent.contentId}`}>
                <div className="col text-truncate pr-0">
                  {
                    promotionStepContentList.find(
                      content => content.contentId === currentContent.contentId
                    ).content.name
                  }
                </div>
                <div
                  className="col-auto pr-0 remove-selected-credit"
                  onClick={() => this._deselectContent(currentContent)}
                  role="button"
                  tabIndex={0}
                  aria-label="Remove selected credit"
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      this._deselectContent(currentContent)
                    }
                  }}
                >
                  <i className="fas fa-times-circle" />
                </div>
              </div>
            ))
          ) : (
            <div className="col text-truncate pr-0 empty-text">
              <FormattedMessage id="page.redemptionPage.text.selectedNone" />
            </div>
          )}
        </div>
      </div>
    )
  }

  _renderRedeemedCredits = () => {
    const redeemedContent = this._getRedeemedContent()
    return (
      <div className="card h-100 select-selected-credits">
        <div className="card-body">
          <h6>
            <FormattedMessage id="global.label.redeemedCredits" />
          </h6>
          <div className="hr mb-2" />
          {redeemedContent && redeemedContent.length > 0 ? (
            redeemedContent.map(currentContent => (
              <div className="row m-0 mb-2" key={`selected-content-${currentContent.contentId}`}>
                <div className="col text-truncate pr-0">{currentContent.content.name}</div>
              </div>
            ))
          ) : (
            <div className="col text-truncate pr-0 empty-text">
              <FormattedMessage id="page.redemptionPage.text.selectedNone" />
            </div>
          )}
        </div>
      </div>
    )
  }

  renderContent = () => {
    const promotionStepContentList = this._getPromotionStepContentList()
    const redeemedContent = this._getRedeemedContent()
    const { error } = this.props
    const { activeContentId } = this.state
    const { currentPromotion } = this.props
    if (!currentPromotion && !error) {
      return <Loader noBorder />
    }
    if (error) {
      return <Error message="error.coupon.couponNoPromotion" />
    }
    return (
      <div aria-labelledby="select-current-promotion-heading">
        <div className="row">
          <div className="col">
            <h4 id="select-current-promotion-heading">{currentPromotion.name}</h4>
            {this._renderGameAndSoftwareCount()}
          </div>
        </div>
        <div className="row mb-5">
          <div className="col-12 col-lg-3 order-lg-last">
            <div className="row flex-lg-column h-100">
              <div className="col mb-lg-4">{this._renderSelectedCredits()}</div>
              <div className="col text-truncate">{this._renderRedeemedCredits()}</div>
            </div>
          </div>
          <div className="col order-lg-first mt-4 mt-lg-0">
            <div className="card">
              <div className="card-body">
                <h6>
                  <FormattedMessage id="global.label.availableRewards" />
                </h6>
                <div className="row">
                  <div className="col-12 col-md-4 select-credits-list-container">
                    <ul className="select-credits-list">
                      {promotionStepContentList &&
                        promotionStepContentList.map((content, idx) => {
                          const index = redeemedContent
                            .map(e => e.contentId)
                            .indexOf(content.contentId)
                          if (index !== -1) {
                            return (
                              <li key={`available-content-${content.contentId}-${idx}`}>
                                <s>
                                  <a>{content.content.name}</a>
                                </s>
                              </li>
                            )
                          }
                          return (
                            <li key={`available-content-${content.contentId}-${idx}`}>
                              <a
                                href="#"
                                className={content.contentId === activeContentId ? 'active' : ''}
                                onClick={e => this._setActiveContent(e, content)}
                              >
                                {content.content.name}
                              </a>
                            </li>
                          )
                        })}
                    </ul>
                  </div>
                  <SelectContent
                    activeContent={this._getActiveContent()}
                    currentContentList={this._getCurrentContentList()}
                    redeemedContent={this._getRedeemedContent()}
                    currentCreditsUsed={this._getCurrentCredits()}
                    maximumSelections={this._getMaximumSelections()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ClaimNavigation />
      </div>
    )
  }

  render() {
    return (
      <div>
        <NoMoreCreditsModal isOpen={this.state.modalOpen} toggle={this._toggleModal} />
        {this.renderContent()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  selectedContentList: state.claimReducers.selectedContentList,
  promotionStepContentList: state.claimReducers.promotionStepContentList,
  couponCode: state.claimReducers.couponCode,
  currentPromotion: state.claimReducers.currentPromotion,
  activePromotionStepId: state.claimReducers.activePromotionStepId,
  error: state.claimReducers.error,
})

const mapDispatchToProps = dispatch => ({
  selectContent: (...args) => dispatch(claimActions.selectContent(...args)),
  deselectContent: (...args) => dispatch(claimActions.deselectContent(...args)),
  setActivePromotionStep: (...args) => dispatch(claimActions.setActivePromotionStep(...args)),
  getPromotionByCouponCode: (...args) => dispatch(claimActions.getPromotionByCouponCode(...args)),
  clearRedeemState: () => dispatch(claimActions.clearRedeemState()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Select)
